import React from 'react'
import moment from 'moment'
import classNames from 'classnames'
import { BrandLogos } from '../../images'
import NProgress from 'nprogress/nprogress.js'
require('style-loader!css-loader!nprogress/nprogress.css')
const HeaderConfig = require('TENANT_CONFIG').customerApplication.header;

const Logo = ({ companyName, locale }) => {
  const logoConfig = BrandLogos[locale];
  let props = { alt: `${companyName} logo`, focusable: false };
  if (logoConfig.svg) {
    props.src = logoConfig.svg;
  } else {
    props.src = logoConfig['1x'];
    props.srcSet = `${logoConfig['1x']} 1x, ${logoConfig['2x']} 2x`;
  }
  return <img {...props} />
}
/**
 * Depending on where the information comes from
 * type can be either credit_card (from application)
 * or credit_card_account (from product itself)
 * easiest to account for both cases
 * @param {string} type
 * @returns {boolean}
 */
const isCard = type => type === 'credit_card' || type === 'credit_card_account';

export class DashboardHeader extends React.Component{
  constructor(props, ctx){
    super(props, ctx)
    this.progress = null
    this.state = {open: false}
    this.loading = this.context.store.getState().data.loading
    this.clickDocument = this.clickDocument.bind(this)
    this.onDataLoaded  = this.onDataLoaded.bind(this)
  }

  onDataLoaded(){
    const { loading } = this.context.store.getState().data
    if(loading > 0 && this.progress === null){
      this.progress = NProgress.start()
    }else if(loading === 0 && this.progress){
      this.progress.done()
      this.progress = null
    }else if(loading < this.loading){
      this.progress.inc()
    }else if(loading === 0){
      this.progress.done(true)
      this.progress.remove()
      this.progress = null
    }
    this.loading = loading
  }

  clickDocument(event){
    if(event.target == this.refs.myAccountButton || event.target == this.refs.chevron) return;
    this.setState({open: false})
  }

  componentDidMount(){
    this.context.store.subscribe(this.onDataLoaded)
    document.addEventListener('click', this.clickDocument)
  }

  componentWillUnmount(){
    this.context.store.unsubscribe(this.onDataLoaded)
    if(this.progress){
      this.progress.remove()
      this.progress = null
    }
    document.removeEventListener('click', this.clickDocument)
  }

  toggleHeader = () => {
    this.setState(({ open }) => ({ open: !open }));
  }

  render(){
    const { customer: { first_name } } = this.props
    const { components: { Alerts = () => null} } = this.props
    const { products, locale, t } = this.props
    const drawerStyle = classNames({
      'header__drawer': true,
      'header__drawer--open': this.state.open
    })

    const headerIconStyle = classNames('header__icon-arrow', {
      'header__icon-arrow--down': !this.state.open,
      'header__icon-arrow--up': this.state.open
    });

    /** @type {Array<{ product_type: string | null }>} */
    const nonCardProducts = products.filter(p => !!p && !isCard(p.product_type));
    /** @type {Boolean} */
    const showPaymentMethod = !!nonCardProducts.filter(p => !!p.payment_method).length;
    /** @type {Boolean} */
    const showPersonalInformation = !!nonCardProducts.length;
    const showQuestions = HeaderConfig.questions;
    /* The badge is a logo at the right of the header, used by TD */
    const showBadge = HeaderConfig.show_badge;
    const drawerOpen = this.state.open;

    const contactUsModalType = HeaderConfig.contactUs;

    const showFaq = HeaderConfig.faq;
    const faqElement = <li><a href="/faq" target="_blank">FAQ</a></li>;

    if (contactUsModalType === 'remodal') {
      var contactUsModalElement = <li><a href='javascript:void(0)' data-remodal-target='contact_us'>Contact Us</a></li>;
    }
    else if (contactUsModalType === 'amount') {
      var contactUsModalElement = <li><amount-modal-anchor template-id='contact_us'>Contact Us</amount-modal-anchor></li>;
    }

    return(
      <div>
        <header styleName="header">
          <div styleName="header__logo">
            <a href="/" aria-label={`Link to ${t('company_name')} homepage`}>
              <Logo locale={locale} companyName={t('company_name')} />
            </a>
          </div>
          {
            /**
            * The header links may be shown/hidden/styled by ApplicationCtrl
            * if header.myAccountDropdownDisabledOn is set in src/config
            */
          }
          <ul styleName="header__links header__links--desktop-only header__links--hide" id="left-header-links">
            { showFaq && faqElement }
            { showQuestions && <li><a href={t(`support_url`)}>Questions?</a></li> }
            { contactUsModalType && contactUsModalElement }
          </ul>
          <div styleName='header__drawer-link' id="my-account-dropdown">
            <a
              href="javascript:void(0)"
              data-header-nav
              aria-controls="drawer"
              aria-haspopup="menu"
              aria-expanded={drawerOpen}
              ref="myAccountButton"
              onClick={this.toggleHeader}
              id="header-drawer-link"
            >
              My Account
              <i styleName={headerIconStyle} ref='chevron' aria-hidden='true' focusable='false' />
            </a>
          </div>
          <div
            id="drawer"
            aria-expanded={drawerOpen}
            aria-labelledby="header-drawer-link"
            styleName={drawerStyle}
            data-header-drawer=""
            role="menu"
          >
            <ul data-header-drawer>
              { showFaq && faqElement }
              { showQuestions && <li><a href="http://support.avant.com">Questions?</a></li> }
              { contactUsModalType && contactUsModalElement }
              { showPaymentMethod && <li><a href="/dashboard#/payment_method">Payment Method</a></li> }
              { showPersonalInformation && <li><a href="/dashboard#/personal_information">Personal Information</a></li> }
              <li><a href="/logout">Logout</a></li>
            </ul>
          </div>
          {
            showBadge && (
              <div styleName="header__badge">
                <picture>
                  <source srcSet={BrandLogos[locale]['primaryLogo']} media='(min-width: 600.1px)' />
                  <img src={BrandLogos[locale]['secondaryLogo']} srcSet={BrandLogos[locale]['secondaryLogo']} alt={t('company_name')} />
                </picture>
              </div>
            )
          }
        </header>
        <Alerts />
      </div>
    )
  }
}

DashboardHeader.contextTypes = {
  store: React.PropTypes.object
}

export const Container = (props) => {
  const { components: { Header = () => null }} = props
  return(
    <div styleName="container">
      <Header />
    </div>
  )
}

export const DashboardGreeting = (props) => {
  const time = typeof avant !== 'undefined' && avant.server_time ? avant.server_time : new Date()
  return(
    <section styleName="intro">
      <h1 styleName="intro__headline headline headline--effra">{props.first_name ? `Hello, ${props.first_name}.` : 'Welcome.'}</h1>
      <span styleName="intro__subhead">Today is {moment(time).format('dddd, MMMM D, YYYY')}</span>
    </section>
  )
}

export const DashboardContainer = (props) => {
  const {components: { Elements = [], Intro }} = props
  return(
    <main styleName="container">
      <div styleName="container__inner">
        <Intro />
        <article styleName="col__wide-left">
          {Elements.map((Elem, key) => {
            return <Elem {...{key}} />
          })}
        </article>
      </div>
    </main>
  )
}

/**
* Need to refactor this
*/
export const DashboardNoAction = (props) => {
  const { t, notice } = props
  if(!notice || !notice.call_to_action || !notice.call_to_action.url) return null

  // @todo giant hack, will rework soon
  if(t('company_name') === 'Eloan') {
    return(
      <div styleName="container__inner">
        <section styleName="noaction">
          <h1 styleName="noaction__header headline--effra">Loans empower people to fuel their dreams, and {t('company_name')} is here to help.</h1>
          <h2 styleName="noaction__subheader headline--light"></h2>
          <a href={notice.call_to_action.url} styleName="button button--primary">
            <span>Apply For A Loan Today</span>
            <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
          </a>
        </section>
      </div>
    )
   }
  else if(t('company_name') === 'TD') {
    return(
      <div styleName="container__inner">
        <section styleName="noaction">
          <h1 styleName="noaction__header headline--effra">Loans empower people to fuel their dreams, and {t('company_name')} is here to help.</h1>
          <h2 styleName="noaction__subheader headline--light"></h2>
          <a href={notice.call_to_action.url} styleName="button button--primary">
            <span>Apply For A Loan Today</span>
            <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
          </a>
        </section>
      </div>
    )
   }
   else {
    return(
      <div styleName="container__inner">
        <section styleName="noaction">
          <h1 styleName="noaction__header headline--effra">Over 600,000 people have experienced the convenience of personal loans through Avant.</h1>
          <img src={require('!!file-loader!@amount/frontend-styles/src/images/dec/dec-noaction.svg')} styleName="noaction__img" alt="Apply for a loan today" />
          <h2 styleName="noaction__subheader headline--light">Apply for a loan today</h2>
          <a href={notice.call_to_action.url} styleName="button button--primary">
            <span>Check Your Loan Options</span>
            <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
          </a>
          <p styleName="noaction__blurb">Checking your loan options <strong>does not</strong> affect your FICO<sup>®</sup> score</p>
        </section>
      </div>
    )
   }
}

/**
* Need to refactor this
*/
export const DashboardNoActionAvant = (props) => {
  const { notice } = props
  if(!notice || !notice.call_to_action || !notice.call_to_action.url) return null
  return(
    <div styleName="container__inner">
      <section styleName="noaction">
        <h1 styleName="noaction__header headline--effra">Over 600,000 people have experienced the convenience of personal loans through Avant.</h1>
        <img src={require('!!file-loader!@amount/frontend-styles/src/images/dec/dec-noaction.svg')} styleName="noaction__img" alt="Apply for a loan today" />
        <h2 styleName="noaction__subheader headline--light">Apply for a loan today</h2>
        <a href={notice.call_to_action.url} styleName="button button--primary">
          <span>Check Your Loan Options</span>
          <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
        </a>
        <p styleName="noaction__blurb">Checking your loan options <strong>does not</strong> affect your FICO<sup>®</sup> score</p>
      </section>
    </div>
  )
}
